import React, { useEffect, useState } from "react";
import { Main, Content } from "../../../components/Layout";
import api from "../../../services/api";
import { ChartsBar } from "../../../components/Charts";
import { Col, Row, Table, Form } from "react-bootstrap";
import DatePicker from "../../../components/DatePicker";
import Slct from "../../../components/Slct";
import tableStyle from "../../../components/Table/Table.module.css";
import getCommercial from "../../../util/getCommercial";
import { IntegerNumber } from "../../../components/Input";
import IcX from "../../../components/Svg/IcX";
import EmptyError from "../../../components/EmptyError";
import { ModalAddTask } from "../../../components/Modal";
import Loading from "../../../components/Loading";
import IcEditar from "../../../components/Svg/IcEditar";
import { PrintPage } from "../../../components/PrintPage";
import useWrapper from "../../../hooks/useWrapper";
import TableResponsive from "../../../components/TableResponsive";
import StatusFlag from "../../../components/StatusFlag";
import useFormat from "../../../hooks/utils/useFormat";

export default function ReportsCalendar() {
  const { setbreadcrumb, me, config } = useWrapper();

  const { formatDate, capitalizeFirst, stringToDate } = useFormat();

  const [pageloaded, setpageloaded] = useState(false);
  const [reload, setreload] = useState();
  const [tasks, settasks] = useState([]);
  const [groups, setgroups] = useState([]);
  useEffect(() => {
    setpageloaded(false);
    api
      .get("calendars", config)
      .then(resp => {
        settasks(
          resp.data.map(e => {
            let _status = null;
            let today = new Date();
            if (e.done) {
              _status = "concluida";
            } else if (e.status === "canceled") {
              _status = "cancelada";
            } else if (stringToDate(e.date_start) > today) {
              if (e.status === "foreseen") {
                _status = "prevista";
              } else if (e.status === "confirmed") {
                _status = "confirmada";
              }
            } else if (stringToDate(e.date_start) < today) {
              _status = "atrasada";
            }
            return {
              ...e,
              _status: _status,
            };
          }),
        );
      })
      .then(() => {
        getCommercial(null, null, "?", "", true).then(resp => {
          setgroups(
            [
              {
                value: null,
                label: "-- Todas --",
              },
            ].concat(resp),
          );
          setpageloaded(true);
        });
      });
  }, [reload]);

  const filter_init = {
    "Data Inicial": "",
    "Data Final": "",
    Ano: "",
    Período: "",
    Status: [
      { value: "prevista", label: "Previstas" },
      { value: "confirmada", label: "Confirmadas" },
      { value: "atrasada", label: "Atrasadas" },
    ],
  };
  const [filter, setFilter] = useState(filter_init);

  const [reports, setReports] = useState({
    data: [],
    title: "",
    type: "",
  });
  useEffect(() => {
    let _tasks = [...tasks];

    if (filter["Status"].length > 0) {
      let _tasks_status = [];
      filter["Status"].forEach(e => {
        _tasks_status = _tasks_status.concat(_tasks.filter(e2 => e2._status === e.value));
      });
      _tasks = _tasks_status;
    }

    if (filter["Data Inicial"]) {
      _tasks = _tasks.filter(e => stringToDate(e.date_start) >= filter["Data Inicial"]);
    }
    if (filter["Data Final"]) {
      _tasks = _tasks.filter(e => stringToDate(e.date_start) <= filter["Data Final"]);
    }
    if (filter.group) {
      _tasks = _tasks.filter(e => e.commercial_id === filter.group);
    }
    if (filter["Ano"]) {
      _tasks = _tasks.filter(e => e.commercial && e.commercial.year.includes(filter["Ano"]));
    }
    if (filter["Período"]) {
      _tasks = _tasks.filter(e => e.commercial && e.commercial.period.includes(filter["Período"]));
    }
    if (filter["Nome"]) {
      _tasks = _tasks.filter(__task => __task.title.toUpperCase().includes(filter["Nome"].toUpperCase()));
    }

    let _table = _tasks.map(e => ({
      label: e.title,
      type: e._status,
      color: filter["Status"].findIndex(e2 => e2.value === e._status) + 1,
      date: e.date_start,
      group: e.commercial
        ? `${e.commercial.course.title} ${e.commercial.year}.${e.commercial.period} (${
            !!e.commercial.institution ? e.commercial.institution.title : "?"
          })`
        : "-",
      id: e.id,
    }));
    setReports({
      data: filter["Status"].map(e => ({
        label: e.label,
        value: _tasks.filter(e2 => e2._status === e.value).length,
      })),
      title: "Tarefas Pendentes",
      type: "tarefas",
      table: _table,
    });
  }, [JSON.stringify(filter), tasks]);

  const [modalOpen, setmodalOpen] = useState(null);

  useEffect(() => {
    setbreadcrumb([{ label: "Relatórios" }]);
  }, []);

  return (
    <PrintPage has_logo={true} signed_by={me.username}>
      <Main>
        <ModalAddTask
          reload={reload}
          reloadCalendar={() => {
            setreload(!reload);
          }}
          itemId={modalOpen}
          show={modalOpen}
          onHide={() => setmodalOpen(null)}
        />
        {pageloaded ? (
          <Content>
            <Row>
              <Col>
                <div className="d-flex justify-content-between">
                  <h2 className="page-title">Tarefas</h2>
                  <div className="d-flex ml-4">
                    <PrintPage.PrintButton label="Gerar PDF" />

                    <PrintPage.CSVButton
                      label="Gerar CSV"
                      title={reports.title}
                      overview={reports.data}
                      table={reports?.table?.map(_row => ({
                        ...(_row.label !== undefined && { Tarefa: _row.label }),
                        ...(_row.type !== undefined && { Status: _row.type }),
                        ...(_row.group !== undefined && { Turma: _row.group }),
                        ...(_row.date !== undefined && { Data: formatDate(_row.date, 1) }),
                      }))}
                      signed_by={me.username}
                      filter={{
                        ...filter,
                        Status: filter["Status"].map(__status => __status.label),
                      }}
                    />
                  </div>
                </div>
              </Col>
            </Row>
            <Row className="mt-2" style={{ zIndex: 10, position: "relative" }}>
              <Col sm={3}>
                <span className="lince-input_label">Data Inicial</span>
                <DatePicker
                  canClear
                  selected={filter["Data Inicial"]}
                  changeDate={e => {
                    setFilter({
                      ...filter,
                      "Data Inicial": e,
                    });
                  }}
                />
              </Col>
              <Col sm={3}>
                <span className="lince-input_label">Data Final</span>
                <DatePicker
                  canClear
                  selected={filter["Data Final"]}
                  changeDate={e => {
                    setFilter({
                      ...filter,
                      "Data Final": e,
                    });
                  }}
                />
              </Col>
              <Col sm={3}>
                <span className="lince-input_label">Turma</span>
                <Slct
                  className="w-100"
                  options={groups}
                  placeholder="..."
                  value={filter.group}
                  onChange={e => {
                    setFilter({
                      ...filter,
                      group: e.value,
                    });
                  }}
                />
              </Col>
              <Col sm={3}>
                <Row className="ano-periodo">
                  <Col sm={7} className="pr-0">
                    <span className="lince-input_label mb-1">Ano/Período</span>
                    <div className="lince-input__text">
                      <IntegerNumber
                        value={filter["Ano"]}
                        valueChange={ev => {
                          setFilter({
                            ...filter,
                            init: false,
                            Ano: ev || "",
                          });
                        }}
                        maxlength="4"
                      />
                    </div>
                  </Col>
                  <Col className="d-flex align-items-end pl-0">
                    <Slct
                      className="w-100"
                      options={[
                        { value: "", label: "1 e 2" },
                        { value: 1, label: "1" },
                        { value: 2, label: "2" },
                      ]}
                      placeholder="..."
                      value={filter["Período"]}
                      onChange={e => {
                        setFilter({
                          ...filter,
                          init: false,
                          Período: e.value,
                        });
                      }}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row className="mt-2">
              <Col sm={6}>
                <span className="lince-input_label mb-1">Status</span>
                <Slct
                  className="w-100"
                  options={[
                    { value: "prevista", label: "Previstas" },
                    { value: "confirmada", label: "Confirmadas" },
                    { value: "cancelada", label: "Canceladas" },
                    { value: "atrasada", label: "Atrasadas" },
                    { value: "concluida", label: "Concluídas" },
                  ]}
                  isMulti="true"
                  placeholder="..."
                  value={filter["Status"] || []}
                  onChange={ev => {
                    setFilter({
                      ...filter,
                      Status: ev,
                    });
                  }}
                />
              </Col>
              <Col sm={3}>
                <Form.Group className="lince-input">
                  <span className="lince-input_label">Nome</span>
                  <div className="lince-input__text">
                    <Form.Control
                      type="text"
                      value={filter["Nome"]}
                      placeholder="..."
                      onChange={e => {
                        setFilter({
                          ...filter,
                          init: false,
                          Nome: e.target.value,
                        });
                      }}
                    />
                  </div>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={12}>
                <button
                  onClick={() => {
                    setFilter(filter_init);
                  }}
                  className={`clear-search ${
                    JSON.stringify(filter) === JSON.stringify(filter_init) ? "disabled" : "mt-3"
                  }`}
                >
                  <span>
                    <span>
                      <IcX />
                    </span>
                    <span>Limpar busca</span>
                  </span>
                </button>
              </Col>
            </Row>
            <Row>
              <Col>
                <ChartsBar reports={reports.data} title={reports.title} type={reports.type} />
                {reports.table && (
                  <TableResponsive
                    className="mt-4"
                    table={{
                      head: [{ data: "Tarefa" }, { data: "Turma" }, { data: "Data" }, { data: "" }],
                      body:
                        reports?.table?.map(__report => ({
                          data: [
                            { element: __report.label },
                            { element: __report.group },
                            { element: formatDate(__report.date, 1) },
                            {
                              element: (
                                <div style={{ textAlign: "right" }}>
                                  <StatusFlag
                                    style={{ backgroundColor: `var(--color-cycle-${__report.color})` }}
                                    status={capitalizeFirst(__report.type)}
                                  />
                                </div>
                              ),
                            },
                          ],
                          border: `var(--color-cycle-${__report.color})`,
                          onClick: () => {
                            setmodalOpen(__report.id);
                          },
                        })) || [],
                    }}
                  />
                )}
              </Col>
            </Row>
          </Content>
        ) : (
          <Content>
            <Loading />
          </Content>
        )}
      </Main>
    </PrintPage>
  );
}
